import { gql } from "@apollo/client";
import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Analytics } from "@vercel/analytics/react";
import sanityClient from "./client.js";

import Home from "./views/Home";
import Playlists from "./views/Playlists";
import Archive from "./views/Archive";
import Radio from "./views/Radio";

import Nav from "./components/global/Nav";
import Drawer from "./components/global/Drawer";
import Player from "./components/global/Player.js";
import Intro from "./components/global/Intro.js";
import Background from "./components/global/Background.js";

import "./styles/global-styles.scss";

function App(props) {
  const { client } = props;
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(false);
  const [currentPage, setCurrentPage] = useState("home");

  const [drawerMix, setDrawerMix] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const [mixesData, setMixesData] = useState([]);
  const [playlistsData, setPlaylistsData] = useState([]);

  const [playingMix, setPlayingMix] = useState();
  const [playerOpen, setPlayerOpen] = useState(false);

  const [sanityData, setSanityData] = useState([]);

  const [latestMixes, setLatestMixes] = useState([]);

  useEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement;
      doc.style.setProperty("--app-height", `${window.innerHeight}px`);
    };
    window.addEventListener("resize", appHeight);
    appHeight();
    return () => window.removeEventListener("resize", appHeight);
  }, []);

  useEffect(() => {
    const checkWidth = () => {
      if (window.innerWidth < 750) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    checkWidth();
    window.addEventListener("resize", checkWidth, false);
  });

  const ARCHIVE_PLAYLISTS = ["2058317538", "2058317946", "2058318099"];
  const THEME_PLAYLISTS = [
    "2058311598",
    "2057918580",
    "2058311865",
    "2058312024",
    "2058312210",
    "2058312345",
    "2058312516",
    "2058312651",
    "2058312810",
    "2058313077",
    "2058313146",
    "2058313263",
    "2058313584",
    "2058313746",
    "2058313845",
    "2058313956",
    "2058314070",
    "2058314133",
    "2058314238",
    "2058314298",
    "2058314499",
    "2058314772",
    "2058314985",
    "2058315186",
    "2058315420",
    "2058315747",
    "2058315993",
    "2058316122",
    "2058316200",
    "2058316323",
    "2058316434",
    "2058316797",
    "2059256457",
    // "2059145001",
  ];

  // function findMissingMixNumbers(data) {
  //   const presentNumbers = new Set(data.map((item) => item.mixNumber));
  //   const missingNumbers = [];

  //   for (let i = 1; i <= 1000; i++) {
  //     const padded = i.toString().padStart(3, "0");
  //     if (!presentNumbers.has(padded)) {
  //       missingNumbers.push(padded);
  //     }
  //   }

  //   return missingNumbers;
  // }

  // function findRepeatedMixNumbersWithCount(data) {
  //   const countMap = new Map();

  //   for (const item of data) {
  //     const mixNumber = item.mixNumber;
  //     countMap.set(mixNumber, (countMap.get(mixNumber) || 0) + 1);
  //   }

  //   const repeated = [];
  //   for (const [mixNumber, count] of countMap.entries()) {
  //     if (count > 1) {
  //       repeated.push({ mixNumber, count });
  //     }
  //   }

  //   return repeated;
  // }

  const formatNameAndNumber = (array) => {
    const sortedData = array
      .map((mix) => {
        const match = mix.title.match(/^RA\.(\d+)\s+(.*)$/);
        if (!match) return mix;

        return {
          ...mix,
          mixNumber: match[1],
          artistName: match[2],
        };
      })
      .sort((a, b) => Number(b.mixNumber) - Number(a.mixNumber));
    array = sortedData;

    const sortedDates = sortedData.map((mix) => {
      if (mix.releaseDay && mix.releaseMonth && mix.releaseYear) {
        const releaseDate = `${mix.releaseYear}${String(
          mix.releaseMonth,
        ).padStart(2, "0")}${String(mix.releaseDay).padStart(2, "0")}`;

        return {
          ...mix,
          releaseDate: releaseDate,
        };
      }

      if (!mix.releaseDay || !mix.releaseMonth || !mix.releaseYear) return mix;
    });
    setLatestMixes(sortedDates.slice(0, 100));
    setMixesData(sortedDates);
  };

  useEffect(() => {
    client
      .query({
        query: gql`
          query GET_SOUND_CLOUD_PLAYLISTS {
            soundCloudPlaylists {
              id
              title
              description
              urn
              genre
              tags
              artworkUrl
              likesCount
              releaseDay
              releaseMonth
              releaseYear
              trackCount
              tracks {
                id
                uri
                urn
                title
                description
                genre
                metadataArtist
                tags
                duration
                playbackCount
                likesCount
                artworkUrl
                streamUrl
                waveformUrl
                releaseDay
                releaseMonth
                releaseYear
              }
            }
          }
        `,
      })
      .then((data) => {
        const selectedTracks = data.data.soundCloudPlaylists
          .filter((item) => ARCHIVE_PLAYLISTS.includes(item.id))
          .flatMap((item) => item.tracks || []);
        formatNameAndNumber(selectedTracks);
        // console.log(selectedTracks);

        // FOR FINDING PLAYLIST IDS
        // data.data.soundCloudPlaylists.forEach(pl =>{
        //   console.log(pl.title, pl.id);
        // })

        //  FOR FINDING TRACKIDS
        // data.data.soundCloudPlaylists[0].tracks.forEach(track =>{
        //   console.log(track.title, track.urn, track.id);
        // })

        const selectedPlaylists = THEME_PLAYLISTS.map((id) =>
          data.data.soundCloudPlaylists.find((item) => item.id === id),
        ).filter(Boolean);

        setPlaylistsData(selectedPlaylists);
      });
  }, []);

  useEffect(() => {
    sanityClient
      .fetch(
        `{"carousel": *[_type == "latest"][0]{
          ...,
          mixes[]->{
            ...
          }
        },
         "intro": *[_type == "intro"][0]{...}}`,
      )
      .then((data) => {
        setSanityData(data);
      })
      .catch(console.error);
  }, []);

  return (
    <>
      <Analytics />
      <Intro {...{ sanityData }} />
      <Background {...{ isMobile }} />
      <Nav
        {...{
          isMobile,
          currentPage,
          setCurrentPage,
          setDrawerOpen,
          setDrawerMix,
        }}
      />
      <Drawer
        {...{
          isMobile,
          drawerMix,
          setDrawerMix,
          drawerOpen,
          setDrawerOpen,
          playingMix,
          setPlayingMix,
          setPlayerOpen,
        }}
      />
      <Player
        {...{
          isMobile,
          playingMix,
          setPlayingMix,
          drawerMix,
          setDrawerMix,
          setDrawerOpen,
          playerOpen,
          setPlayerOpen,
        }}
      />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            element={
              <Home
                key={"Home"}
                {...{
                  isMobile,
                  sanityData,
                  mixesData,
                  latestMixes,
                  currentPage,
                  setCurrentPage,
                  drawerMix,
                  setDrawerMix,
                  drawerOpen,
                  setDrawerOpen,
                  playingMix,
                  setPlayingMix,
                  setPlayerOpen,
                }}
              />
            }
            path="/"
          />
          <Route
            element={
              <Playlists
                key={"Playlists"}
                {...{
                  isMobile,
                  mixesData,
                  currentPage,
                  setCurrentPage,
                  playlistsData,
                  drawerMix,
                  setDrawerMix,
                  drawerOpen,
                  setDrawerOpen,
                  playingMix,
                  setPlayingMix,
                  setPlayerOpen,
                }}
              />
            }
            path="/playlists"
          />
          <Route
            element={
              <Radio
                key={"Radio"}
                {...{
                  isMobile,
                  currentPage,
                  setCurrentPage,
                }}
              />
            }
            path="/radio"
          />
          <Route
            element={
              <Archive
                key={"Archive"}
                {...{
                  isMobile,
                  currentPage,
                  setCurrentPage,
                  drawerMix,
                  setDrawerMix,
                  drawerOpen,
                  setDrawerOpen,
                  mixesData,
                  setMixesData,
                }}
              />
            }
            path="/archive"
          />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
